// src/components/Help.js
import React, { useState } from 'react';
import { Link } from 'react-router-dom';

const FIFO_ARTICLE = {
  title: 'ระบบ FIFO คืออะไร? และการทำงานร่วมกับใบเช่าเครื่อง',
  date: '20 มีนาคม 2569',
  sections: [
    {
      heading: 'ภาพรวมของระบบ',
      content: `ระบบ VERP ออกแบบมาเพื่อรองรับกระบวนการทำงานตั้งแต่การรับใบสั่งขาย (SO) จาก NetSuite ไปจนถึงการส่งมอบเครื่องให้ลูกค้า โดยแบ่งออกเป็น 2 เส้นทางหลักที่ทำงานควบคู่กัน ได้แก่ เส้นทางเอกสารสัญญา และเส้นทาง FIFO สำหรับจัดการเครื่องจากคลังสินค้า`
    },
    {
      heading: '1. แดชบอร์ด — ตรวจจับ SO เช่าเครื่อง',
      content: `ระบบจะดึงข้อมูล SO จาก NetSuite โดยอัตโนมัติ และแสดง SO ที่เป็นประเภทเช่าเครื่องบนแดชบอร์ด ทีมขายหรือทีมประสานงานขาย (Sale Co) สามารถดูรายการที่รอดำเนินการได้ทันที`
    },
    {
      heading: '2. เอกสารเครื่องเช่า — กรอกข้อมูลสัญญาและลูกค้า',
      content: `เมื่อคลิกเข้าไปใน SO เช่าเครื่อง ทีม Sale Co จะกรอกข้อมูลที่จำเป็น ได้แก่ ข้อมูลลูกค้าและผู้ติดต่อ (ชื่อ, เบอร์โทร, อีเมล), รายละเอียดสัญญา เช่น ประเภทสัญญา, ระยะเวลา (เดือน), วันเริ่มต้น/สิ้นสุด, ประเภทประกัน, ระยะเวลารับประกัน, ระยะเวลาบริการ และสถานที่ติดตั้งพร้อมที่อยู่ไทยแบบละเอียดและพิกัด GPS บนแผนที่`
    },
    {
      heading: '3. เบิกเครื่อง (FIFO) — เลือกเครื่องจากคลัง',
      content: `ทีมคลังสินค้าหรือช่างเทคนิคเปิดหน้า "เบิกเครื่อง" แล้วค้นหาสินค้าด้วยรหัสสินค้า, ชื่อสินค้า หรือ Serial Number ระบบจะแสดงเครื่องที่มีอยู่ในสต็อกตามหลัก FIFO (First In, First Out) คือเครื่องที่เข้ามาก่อนจะถูกจัดสรรก่อน หลังจากเลือกเครื่องแล้ว ต้องกรอกชื่อลูกค้า, ที่อยู่จัดส่ง, วันที่ต้องการรับเครื่อง, รายละเอียดงาน และหมายเหตุเพิ่มเติม`
    },
    {
      heading: '4. รายการคลังสินค้า — ดำเนินการจัดสรร',
      content: `ทีมคลังสินค้าเห็นคำขอเบิกที่เข้ามาและดำเนินการจัดสรร Serial Number ให้กับแต่ละคำขอ`
    },
    {
      heading: '5. ตรวจสอบคุณภาพ (QC) — ตรวจเครื่องก่อนส่ง',
      content: `ทีม QC รับเครื่องต่อจากคลัง ทำการตรวจสอบและบันทึกผล เมื่อผ่านการตรวจสอบแล้ว ระบบจะสร้าง QC Work Order PDF โดยอัตโนมัติ พร้อมส่งแจ้งเตือนผ่าน Telegram ไปยังทีมที่เกี่ยวข้อง`
    },
    {
      heading: 'สรุปเส้นทางการทำงาน',
      content: `SO ใหม่ (NetSuite) → แดชบอร์ด → Sale Co กรอกสัญญา + คลังเบิกเครื่อง FIFO → ตรวจสอบคุณภาพ (QC) → ส่งมอบเครื่องพร้อมเอกสาร PDF`
    }
  ]
};

const Help = () => {
  const [articleOpen, setArticleOpen] = useState(false);

  const tools = [
    {
      id: 'manual-so',
      title_th: 'ประมวลผล Manual SO',
      description: 'SO ไม่เด้งใน Telegram? การเชื่อมต่อของ Veneo และ VERP ล้ม? ลอง Key เลข SO และสร้างเองดูสิ!',
      icon: 'file-earmark-plus-fill',
      color: '#667eea',
      link: '/manual-processor'
    },
    {
      id: 'profile',
      title_th: 'โปรไฟล์ของฉัน',
      description: 'จัดการข้อมูลส่วนตัวและการตั้งค่า',
      icon: 'person-circle',
      color: '#8B5CF6',
      link: '/profile'
    }
  ];

  return (
    <div className="help-page">
      <div className="help-header">
        <div>
          <h2 className="help-title">
            <i className="bi bi-question-circle-fill me-2"></i>
            ช่วยเหลือและเครื่องมือ
          </h2>
          <p className="help-subtitle">เครื่องมือและคู่มือการใช้งานระบบ VERP</p>
        </div>
      </div>

      {/* Quick Tools */}
      <section className="help-section">
        <h3 className="help-section-title">
          <i className="bi bi-tools me-2"></i>
          เครื่องมือด่วน
        </h3>
        <div className="help-tools-grid">
          {tools.map(tool => (
            <Link key={tool.id} to={tool.link} className="help-tool-card">
              <div className="help-tool-icon" style={{ backgroundColor: `${tool.color}15` }}>
                <i className={`bi bi-${tool.icon}`} style={{ color: tool.color }}></i>
              </div>
              <div className="help-tool-content">
                <h4 className="help-tool-title">{tool.title_th}</h4>
                <p className="help-tool-description">{tool.description}</p>
              </div>
              <i className="bi bi-arrow-right help-tool-arrow"></i>
            </Link>
          ))}
        </div>
      </section>

      {/* FIFO Article */}
      <section className="help-section">
        <h3 className="help-section-title">
          <i className="bi bi-book me-2"></i>
          คู่มือการใช้งาน
        </h3>

        <div className="help-article-card">
          <div className="help-article-header" onClick={() => setArticleOpen(o => !o)}>
            <div className="help-article-meta">
              <div className="help-article-icon-wrap">
                <i className="bi bi-arrow-repeat"></i>
              </div>
              <div>
                <h4 className="help-article-title">{FIFO_ARTICLE.title}</h4>
                <span className="help-article-date">{FIFO_ARTICLE.date}</span>
              </div>
            </div>
            <i className={`bi bi-chevron-${articleOpen ? 'up' : 'down'} help-article-toggle`}></i>
          </div>

          {articleOpen && (
            <div className="help-article-body">
              {FIFO_ARTICLE.sections.map((section, i) => (
                <div key={i} className="help-article-section">
                  <h5 className="help-article-heading">{section.heading}</h5>
                  <p className="help-article-text">{section.content}</p>
                </div>
              ))}
            </div>
          )}
        </div>
      </section>

      {/* Contact */}
      <section className="help-section">
        <div className="help-contact-card">
          <div className="help-contact-icon">
            <i className="bi bi-headset"></i>
          </div>
          <div className="help-contact-content">
            <h4 className="help-contact-title">ต้องการความช่วยเหลือเพิ่มเติม?</h4>
            <p className="help-contact-description">
              ติดต่อทีม MIS ได้ที่หมายเลข <strong>136</strong>
            </p>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Help;
